<script>
    // import {Link} from '../router';
    import {createEventDispatcher} from 'svelte/internal';

    export let page = null;
    export let totalItems = null;
    export let target = null;
    export let itemsPerPage = null;
    export let cnt = 12
    let totalPages;
    let startPage = 0;
    let endPage = 0;

    let pages = [];

    const dispatch = createEventDispatcher();

    const onPageChange = (page) => {
        dispatch('change', page);
    }

    $: {
        totalPages = Math.ceil(totalItems / itemsPerPage);
        page = Number(page)
        startPage = page - cnt / 2;
        if (startPage < 1) {
            startPage = 1;
        }
        endPage = startPage + cnt;
        if (endPage > totalPages) {
            endPage = totalPages;
            if (totalPages > cnt) {
                startPage = endPage - cnt;
            }
        }
        pages.length = endPage - startPage + 1;
    }

</script>

{#if (totalPages > 1)}
    <div class="nav-pagination text-right">
        <ul>
            {#if (page > 1)}
                <li>
                    <span on:click="{ () =>  onPageChange(page - 1) }">←</span>
                </li>
            {/if}
            {#if startPage > 2}
                <li>
                    <span on:click="{ () =>  onPageChange(1) }">1</span>
                </li>
            {/if}
            {#each pages as mmm, index}
                <li class:active="{ index + startPage == page }">
                    <span on:click="{ () =>  onPageChange(index + startPage) }">{ index + startPage }</span>
                </li>
            {/each}
            {#if totalPages > 13 && page + 1 < totalPages }
                <li>
                    <span on:click="{ () =>  onPageChange(totalPages) }">{ totalPages }</span>
                </li>
            {/if}
            {#if (page + 1 <= totalPages)}
                <li>
                    <span on:click="{ () =>  onPageChange(page + 1) }">→</span>
                </li>
            {/if}
        </ul>
    </div>
{/if}

<style>
    .nav-pagination {

    }

    .nav-pagination ul {
        display: inline-block;
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .nav-pagination ul:after {
        content: "";
        clear: both;
        display: table;
    }

    .nav-pagination ul > li {
        float: left;
        margin: 0 1px;
        border: 1px solid var(--default-border-color);
        border-radius: 3px;
        list-style: none;
    }

    .nav-pagination ul > li > a, .nav-pagination ul > li > span {
        color: #797979;
        background: #fff;
        border-radius: inherit;
        padding: 5px 10px;
        display: inline-block;
        cursor: pointer;
    }

    .nav-pagination ul > li.disabled a, .nav-pagination ul > li.disabled span {
        color: #c7c7c7;
    }

    .nav-pagination ul > li:hover a, .nav-pagination ul > li.active a, .nav-pagination ul > li:hover span, .nav-pagination ul > li.active span {
        color: #797979;
        background: #e4eaee;
        border-radius: 3px;
    }

    @media (max-width: 991px) {
        .nav-pagination ul > li {
            margin-bottom: 5px;
        }
    }
</style>
